import React, { FC } from 'react'
import { FormGroup, Row, Col, Form } from 'reactstrap';
import { AEAFieldEditor, AEAFieldLabel } from '@components/';
import { Enums, Utilities } from '@utils';
import { AEAItemsSelect } from './aea-field-editor/aea-field-editor';


export interface AEAFieldProps {
    fieldType: Enums.FieldTypes | string;
    id: string;
    readOnly?: boolean;
    placeholder?: string;
    requiredErrorMessage?: string;
    required?: boolean;
    multiple?: boolean;
    items?: AEAItemsSelect[];
    auxItems?: AEAItemsSelect[];
    allItems?: AEAItemsSelect[];
    title?: string;
    description?: string;
    maxLength?:number;  
    layout?: string; 
    defaultValue?:any; 
    showLabel?: boolean;
    showTooltip?: boolean;
    onValueChanged?(value: any, value2?:any): void;  
    value?:any;  
    numberFormat?: string;
}

const AEAField: FC<AEAFieldProps> = (props: AEAFieldProps) => {    
    const getDistributionLabel = () => {
        switch (props.fieldType.toString()){
            case "checkbox": return 8;
            case "number" : return 8;
            case "percentage" : return 8;
            default: return 4;                
        }
    }
    const getDistributionField = () => {        
        if(props.showLabel || Utilities.isNullEmptyObject(props.showLabel)) {
            switch (props.fieldType.toString()){
                case "checkbox": return 4;
                case "number" : return 4;
                case "percentage" : return 4;
                default: return 8;                
            }
        }
        return 12       
    }
    return (
        <FormGroup>
            <Row xs="2" md={2}>
                {props.showLabel !== false &&
                <Col md={getDistributionLabel()} >
                    <AEAFieldLabel {...props} />
                </Col>
                }
                <Col md={getDistributionField()} >
                    <AEAFieldEditor {...props} />
                </Col>
            </Row>
        </FormGroup>
    )
}

export default AEAField;
